import { Skeleton } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';

function PopoverSkeleton() {
  return (
    <>
      <Skeleton size="lg" className="w-24 mb-4" variant="text" />
      <Skeleton size="xs" className="w-11" variant="text" />
      <Skeleton size="xs" className="w-14 my-1" variant="text" />
      <Skeleton size="xs" className="w-12" variant="text" />
      <div className="pr-2">
        <Skeleton size="xs" variant="text" className="mt-4 w-[19rem]" />
        <Skeleton size="xs" variant="text" className="my-1 w-[19rem]" />
        <Skeleton size="xs" variant="text" className="w-2/5" />
      </div>
      <div className="flex flex-wrap mt-4 mb-4">
        <Skeleton className="w-28 mr-4" variant="rectangle" />
        <Skeleton variant="rectangle" className="w-32 mb-2" />
        <Skeleton variant="rectangle" className="w-32 mr-4" />
        <Skeleton className="w-28" variant="rectangle" />
      </div>
      <Skeleton size="sm" variant="rectangle" />
    </>
  );
}

export default observer(PopoverSkeleton);
